<template>
  <div ref="pdfContent" class="pdf-content">
    <CCard class="border-0">
      <CCardHeader v-if="!hideControls" class="no-print bg-transparent">
        <div class="float-right">
          <a href="#" class="btn btn-sm btn-info ml-1" @click="printContent">
            <CIcon name="cil-print" class="mr-1" /> Print
          </a>
        </div>
      </CCardHeader>
      <CCardBody>
        <div class="header">
          <CRow class="align-items-start mb-3">
            <CCol cols="3" md="2" class="text-left">
              <img
                :src="getImageUrl()"
                alt="Logo Syarikat"
                class="logo-image"
              />
            </CCol>
            <CCol cols="9" md="10" class="text-right company-info">
              <h1 class="company-name">{{ company.name }}</h1>
              <p class="company-tagline">{{ company.tagLine }}</p>
              <p class="company-regno">{{ "(" + company.regNo + ")" }}</p>
              <p class="company-address" v-html="formatAddress(company.address)"></p>
              <p class="company-phone">Tel: {{ company.phone }}</p>
            </CCol>
          </CRow>
          <hr class="thick-hr" />
        </div>

        <h3 class="text-center mb-2"><strong>DELIVERY ORDER</strong></h3>

        <div class="mb-2">
          <h5 class="mb-2"><u>PARTICULAR OF VEHICLE</u></h5>
          <table class="table-borderless details-table">
            <tr>
              <td class="label-col"><strong>Name</strong></td>
              <td class="value-col">: {{ getCustomerName() }}</td>
              <td class="label-col"><strong>Date</strong></td>
              <td class="value-col">: {{ getRegistrationDate() }}</td>
            </tr>
            <tr>
              <td class="label-col"><strong>Make</strong></td>
              <td class="value-col">: {{ getBrandModelName() }}</td>
              <td class="label-col"><strong>Chassis No</strong></td>
              <td class="value-col">: {{ getChassisNo() }}</td>
            </tr>
            <tr>
              <td class="label-col"><strong>Regn. No</strong></td>
              <td class="value-col">: {{ getPlateNo() }}</td>
              <td class="label-col"><strong>Engine No</strong></td>
              <td class="value-col">: {{ getEngineNo() }}</td>
            </tr>
            <tr>
              <td class="label-col"></td>
              <td class="value-col"></td>
              <td class="label-col"><strong>Y/Model</strong></td>
              <td class="value-col">: {{ getYear() }}</td>
            </tr>
          </table>
        </div>

        <div class="acknowledgement-section mt-4 mb-2">
          <p>I acknowledge having taken delivery of the above mentioned vehicle from / for</p>
          <p>I will take full responsibility for any offence that may be committed and the damage of the abovesaid vehicle.</p>
        </div>

        <CRow class="checklist-section mb-2">
          <CCol md="6">
            <table class="table-borderless checklist-table">
              <tr>
                <td>ANTENA</td>
                <td><span class="checkbox"></span></td>
              </tr>
              <tr>
                <td>PUMP TYRE</td>
                <td><span class="checkbox"></span></td>
              </tr>
              <tr>
                <td>SPARE KEY</td>
                <td><span class="checkbox"></span></td>
              </tr>
              <tr>
                <td>MANUAL BOOK</td>
                <td><span class="checkbox"></span></td>
              </tr>
              <tr>
                <td>LOCK NUT</td>
                <td><span class="checkbox"></span></td>
              </tr>
              <tr>
                <td>ORI REMOTE REAR MONITOR</td>
                <td><span class="checkbox"></span></td>
              </tr>
            </table>
          </CCol>
          <CCol md="6">
            <table class="table-borderless checklist-table">
              <tr>
                <td>ORIGINAL REGISTRATION CARD</td>
                <td><span class="checkbox"></span></td>
              </tr>
              <tr>
                <td>ORIGINAL ROAD TAX</td>
                <td><span class="checkbox"></span></td>
              </tr>
              <tr>
                <td>COPY CUSTOM DOC (K1, JK8, JK69)</td>
                <td><span class="checkbox"></span></td>
              </tr>
              <tr>
                <td>PHOTOCOPY B2 & B7</td>
                <td><span class="checkbox"></span></td>
              </tr>
              <tr>
                <td>INSURANCE COVERNOTE</td>
                <td><span class="checkbox"></span></td>
              </tr>
              <tr>
                <td>OTHERS</td>
                <td><span class="checkbox"></span></td>
              </tr>
            </table>
          </CCol>
        </CRow>

        <CRow class="mb-5">
          <CCol md="12">
            <p class="mb-1"><strong>REMARKS</strong> : _______________________________________________________________________________</p>
          </CCol>
        </CRow>

        <CRow class="signature-section mt-3">
          <CCol md="6">
            <p class="mb-1"><strong>Delivered by</strong></p>
            <div class="signature-line mt-3 mb-1"></div>
            <p class="mb-0">Signature</p>
            <p class="mb-0">Name</p>
            <p class="mb-0">I/C</p>
          </CCol>
          <CCol md="6">
            <p class="mb-1"><strong>Received by</strong></p>
            <div class="signature-line mt-3 mb-1"></div>
            <p class="mb-0">Signature</p>
            <p class="mb-0">Name</p>
            <p class="mb-0">I/C</p>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import html2pdf from "html2pdf.js";

export default {
  name: "WidgetsReportDeliveryOrder",
  props: {
    stock: {
      type: Object,
      required: true,
    },
    company: {
      type: Object,
      required: true,
      validator: (value) => {
        return ["name", "regNo", "address", "phone"].every(
          (prop) => prop in value
        );
      },
    },
    hideControls: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.forceA4Size();
  },
  methods: {
    forceA4Size() {
      const pdfContent = this.$refs.pdfContent;
      if (pdfContent) {
        pdfContent.style.width = "210mm";
      }
    },
    removeTrailingSlash(str) {
      if (str.endsWith("/")) {
        return str.slice(0, -1);
      }
      return str;
    },
    getImageUrl() {
      var url = this.removeTrailingSlash(apiUrl) + this.company.logoUrl;
      return url;
    },
    formatAddress(address) {
      if (!address) return "";
      return address.replace(/\n/g, "<br>");
    },
    getRegistrationDate() {
      try {
        const raw = this.stock && this.stock.registration && this.stock.registration.vehicleRegistrationDate;
        if (!raw) return "-";
        const d = new Date(raw);
        if (isNaN(d.getTime())) return "-";
        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = String(d.getFullYear()).slice(-2);
        return `${day}.${month}.${year}`;
      } catch (e) {
        return "-";
      }
    },
    getCustomerName() {
      return this.stock.sale?.customer?.name || "";
    },
    getBrandName() {
      return this.stock.vehicle?.brand?.name || "";
    },
    getBrandModelName() {
      try {
        const brand = this.stock.vehicle?.brand?.name || "";
        const model = this.stock.vehicle?.model?.name || "";
        return brand && model ? `${brand} ${model}` : "";
      } catch (error) {
        return "";
      }
    },
    getPlateNo() {
      try {
        return this.stock.registration?.vehicleRegistrationNumber || "";
      } catch (error) {
        return "";
      }
    },
    getChassisNo() {
      try {
        return this.stock.vehicle?.chasisNo || "";
      } catch (error) {
        return "";
      }
    },
    getEngineNo() {
      return this.stock.vehicle?.engineNo || "";
    },
    getYear() {
      return this.stock.vehicle?.year || "";
    },
    printContent() {
      window.print();
    },
  },
};
</script>

<style scoped>
.thick-hr {
  border: 1px solid #000;
  margin: 10px 0;
}

.pdf-content {
  width: 210mm;
  max-width: 100%;
  margin: 0 auto;
  padding: 10mm;
  box-sizing: border-box;
  background-color: white;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  line-height: 1.2;
  color: #333;
  font-size: 12px;
}

.logo-image {
  max-width: 120px;
  height: auto;
  display: block;
}

.header {
  page-break-after: avoid;
  page-break-inside: avoid;
  margin-bottom: 8px;
}

.company-info {
  padding-left: 15px;
}

.company-name {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 3px;
  line-height: 1.1;
}

.company-tagline,
.company-regno,
.company-address,
.company-phone {
  margin-bottom: 2px;
  font-size: 10px;
  line-height: 1.2;
}

.details-table {
  width: 100%;
  table-layout: fixed;
}

.details-table td {
  padding: 3px 6px;
  font-size: 12px;
  line-height: 1.2;
  vertical-align: top;
}

.details-table .label-col {
  width: 18%;
  font-weight: bold;
}

.details-table .value-col {
  width: 32%;
}

.acknowledgement-section {
  font-size: 11px;
  line-height: 1.3;
  page-break-inside: avoid;
}

.acknowledgement-section p {
  margin-bottom: 4px;
}

.checklist-section {
  page-break-inside: avoid;
}

.checklist-table {
  width: 100%;
}

.checklist-table td {
  padding: 3px 6px;
  font-size: 11px;
  line-height: 1.1;
}

.checklist-table td:first-child {
  width: 80%;
}

.checkbox {
  display: inline-block;
  width: 15px;
  height: 15px;
  border: 1.5px solid #000;
  vertical-align: middle;
}

.signature-section {
  margin-top: 10px;
  page-break-inside: avoid;
}

.signature-section p {
  font-size: 11px;
  line-height: 1.2;
}

.signature-line {
  border-bottom: 1px solid #000;
  width: 200px;
  height: 30px;
}

@media print {
  .no-print {
    display: none !important;
  }

  .pdf-content {
    width: 794px;
    margin: 0;
    padding: 12mm;
    box-shadow: none;
    font-size: 11px;
  }

  .pdf-content .card {
    border: none !important;
    box-shadow: none !important;
    background: transparent !important;
  }

  .pdf-content .card-body {
    padding: 0 !important;
  }

  .logo-image {
    max-width: 80px !important;
  }

  .company-name {
    font-size: 14px !important;
  }

  .company-tagline,
  .company-regno,
  .company-address,
  .company-phone {
    font-size: 9px !important;
  }

  h3 {
    font-size: 14px !important;
    margin-bottom: 8px !important;
  }

  h5 {
    font-size: 12px !important;
    margin-bottom: 6px !important;
  }

  body {
    background: white;
    print-color-adjust: exact;
    -webkit-print-color-adjust: exact;
  }

  @page {
    size: A4;
    margin: 15mm;
  }
}

/* PDF Generation specific styles */
.pdf-content.pdf-generation {
  width: 794px !important;
  padding: 0 !important;
  margin: 0;
  font-size: 11px !important;
}

.pdf-content.pdf-generation .card {
  border: none !important;
  box-shadow: none !important;
  background: transparent !important;
}

.pdf-content.pdf-generation .card-body {
  padding: 0 !important;
}

.pdf-content.pdf-generation .no-print {
  display: none !important;
}

.pdf-content.pdf-generation .logo-image {
  max-width: 80px !important;
}

.pdf-content.pdf-generation .company-name {
  font-size: 14px !important;
}

.pdf-content.pdf-generation .company-tagline,
.pdf-content.pdf-generation .company-regno,
.pdf-content.pdf-generation .company-address,
.pdf-content.pdf-generation .company-phone {
  font-size: 9px !important;
}

.pdf-content.pdf-generation h3 {
  font-size: 14px !important;
}

.pdf-content.pdf-generation h5 {
  font-size: 12px !important;
}
</style>
